export default __webpack_public_path__ + "media/images/react_icons/uber-7675db3ecd0fdae75eda07a3cca96cf4.svg";